<template>
  <div>
    <el-tabs v-model="currentTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(item, index) in tabsArr"
        :key="item.value"
        :label="item.label"
        :name="item.value"
      >
        <YsDataTable
          v-if="currentTab === item.value"
          :key="index"
          v-model="refresh"
          :list="searchList"
          :button-list="buttonList"
          :columns="columns"
          :fetch-method="fetchMethod"
          :transform-params="handleFormatSearch"
          page-size-alias="page_size"
          max-height="400"
          :page-sizes="[100, 50, 200]"
          :page-size="100"
          use-data-field
        >
          <template slot="table-content">
            <el-card style="margin-bottom: 16px">
              <el-row>
                <el-col :span="4"> 商家ID:{{ detailData.supply_id }} </el-col>
                <el-col :span="10">
                  商家名称:{{ detailData.supply_name }}
                </el-col>
                <el-col :span="6">
                  生成日期:{{ detailData.report_date }}</el-col
                >
              </el-row>
            </el-card>
          </template>
          <template slot="goods_img" slot-scope="{ row }">
            <img
              style="width: 50px; height: 50px"
              :src="origin + '/' + row.goods_img"
              @click="previewImage(row.goods_img)"
            />
          </template> </YsDataTable
      ></el-tab-pane>
    </el-tabs>
    <preview-image
      :imgs="[dialogImageUrl]"
      :show="isShowBigImage"
      @closeBox="isShowBigImage = false"
    />
  </div>
</template>

<script>
import previewImage from "../../components/PreviewImage.vue";
import { getRejectDateDetail } from "@/controller/erpAfterSale.js";
import Global_ from "../../components/Global.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "RejectStatementDetail",
  components: {
    previewImage,
  },
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      columns: [
        {
          label: "打标ID",
          prop: "dbid",
        },
        {
          label: "图片",
          slot: "goods_img",
        },
        {
          label: "款号",
          prop: "goods_kh",
        },
        {
          label: "货号",
          prop: "goods_no",
        },
        {
          label: "SKU编号",
          prop: "sku",
        },
        {
          label: "颜色",
          prop: "co_val",
        },
        {
          label: "尺码",
          prop: "si_val",
        },
        {
          label: "代采单号",
          prop: "woid",
        },
        {
          label: "代采价",
          prop: "price",
        },
        {
          label: "次品员",
          prop: "dgMemberName",
        },
        {
          label: "来源",
          prop: "referer_type_text",
        },
      ],
      totalDetail: [],
      fetchMethod: getRejectDateDetail,
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: (params) =>
              getRejectDateDetail({ ...params, is_excel: "1" }),
            success: (res) => window.open(apiBaseURL + res.file),
          },
        },
      ],
      searchList: [
        {
          tag: "input",
          field: "goods_no",
          label: "货号",
          props: {
            placeholder: "请输入货号",
          },
        },
        {
          tag: "input",
          field: "sku",
          label: "SKU编号",
          props: {
            placeholder: "请输入SKU编号",
          },
        },
        {
          tag: "input",
          field: "dbid",
          label: "打标ID",
          props: {
            placeholder: "请输入打标ID",
          },
        },
      ],
      refresh: false,
      isShowDetailDialog: false,
      currentTab: "1",
      tabsArr: [],
      dialogImageUrl: "",
      isShowBigImage: false,
      origin: Global_.origin,
    };
  },
  created() {
    this.refresh = true;
    this.tabsArr = [
      {
        value: "1",
        label: `总退换货${this.detailData.total_return}`,
      },
      {
        value: "2",
        label: `转欠货待处理${this.detailData.owe_pending}`,
      },
      {
        value: "3",
        label: `转欠货已换回${this.detailData.owe_processed}`,
      },
      {
        value: "4",
        label: `退款${this.detailData.refund}`,
      },
      {
        value: "5",
        label: `转呆账${this.detailData.stagnant_debts}`,
      },
      {
        value: "6",
        label: `转坏账${this.detailData.bad_debt}`,
      },
      {
        value: "7",
        label: `转抵扣${this.detailData.deduct}`,
      },
    ];
  },
  methods: {
    handleFormatSearch(params) {
      const result = {
        ...params,
        reject_date_log_id: this.detailData.id,
        set_type: this.currentTab,
      };
      this.searchForm = result;
      return result;
    },
    handleTabClick() {
      this.refresh = true;
    },
    previewImage(url) {
      this.dialogImageUrl = `${this.origin}/${url}`;
      this.isShowBigImage = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/reject/RejectStatementDetail.vue